/** @jsxImportSource @emotion/react */

import React, { useState } from 'react';
import { connect } from 'react-redux';

import Actions from 'Redux/Actions';
import { RootState } from 'Redux/store';
import Selectors from 'Redux/Selectors';
import { View } from 'react-native-web';
import NavActions from 'Services/Navigation/Actions';
import { useAppSelector } from 'Redux/hooks';
import LoginSignUpModal from 'Containers/User/LoginSignUpModal';
import { ICartProduct, IProductCategory, IProductCollection } from '@ddot/AddToCartCommon/lib/entities';
import Searchbar from 'Components/Searchbar';

import { css } from '@emotion/react';
import { Modal } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import { headerContainer, mobileHeader, navItem, navText, headerSearchHeader, searchModal, mobileIcon, searchWrapper, inputStyles, mobileIconContainer, mobileCartIndicator } from '../Styles/HeaderStyle';

interface HeaderProps {
    onOpen(): void;
    categoriesLoading: boolean;
    productListLoading: boolean;
    categories: IProductCategory[];
    collections: IProductCollection[];
    cartItems: ICartProduct[];
    setQuery: (query: string | '') => null;
    searchQuery: string;
    userId: string | undefined;
    isLoggedIn: string | undefined;
    startupLoading: boolean;
}
const Header = (props: HeaderProps):JSX.Element => {
    const {
        onOpen, categoriesLoading, productListLoading, categories, collections, cartItems, searchQuery, setQuery, isLoggedIn, startupLoading,
    } = props;

    const [loginModalVisible, setLoginModalVisible] = useState(false);
    const [showSearch, setShowSearch] = useState(false);

    const listProductsCategories = useAppSelector(Selectors.getProductsCategories);

    const handleClick = () => {
        onOpen();
    };

    const handleOnKeyDown = (e: any) => {
        const { value } = e.target;
        if (e.key === 'Enter') {
            if (value.trim()) NavActions.navToProductSearch(value);
        }
    };

    const handleSearch = () => {
        if (searchQuery.trim()) NavActions.navToProductSearch(searchQuery);
        setShowSearch(false);
    };

    const navToHome = () => {
        NavActions.navToHome();
    };

    const navToWishlist = () => {
        if (isLoggedIn) {
            NavActions.navToWishlist();
        } else setLoginModalVisible(true);
    };

    const navToCart = () => {
        NavActions.navToCart();
    };

    const navCategories = (item: IProductCategory) => {
        NavActions.navToProductListingWithCategory(item.id);
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(true);
    };

    const handleProfileClicked = () => {
        const { userId } = props;

        if (userId) {
            NavActions.navToUserProfile();
        } else setLoginModalVisible(true);
    };

    const renderMobileHeader = () => {
        return (
            <div className='headerCont'>
                <div style={{ flex: 1, paddingLeft: 20 }}>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={handleClick}
                        onKeyPress={handleClick}
                    >
                        <img src='/assets/icons/Hamburger.svg' alt='menu' />
                    </div>
                </div>
                <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={navToHome}
                        onKeyPress={navToHome}
                    >
                        <img src='Logo.png' alt='' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                    </div>
                </div>
                <div css={mobileIconContainer}>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={handleProfileClicked}
                        onKeyPress={handleProfileClicked}
                    >
                        <img src='/assets/icons/Account.png' alt='user profile' css={mobileIcon} />
                    </div>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={navToWishlist}
                        onKeyPress={navToWishlist}
                    >
                        <img src='/assets/icons/Like.png' alt='wishlist' css={mobileIcon} />
                    </div>
                    <div
                        role='button'
                        tabIndex={0}
                        onClick={navToCart}
                        onKeyPress={navToCart}
                        style={{ display: 'flex', height: 'auto' }}
                    >
                        <img src='/assets/icons/Cart.png' alt='search icon' css={mobileIcon} />

                        {cartItems.reduce((acc, cur) => acc + cur.quantity, 0) > 0 && (
                            <div style={{ width: 20, height: 20, marginLeft: -10, marginTop: -10, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#064E72', borderRadius: 50 }}>
                                <p css={mobileCartIndicator}>
                                    {cartItems.reduce((acc, cur) => acc + cur.quantity, 0)}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <div css={headerContainer}>
                <div style={{ height: 47 }} />
                <div style={{ paddingTop: '2%', paddingBottom: '2%' }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '5%', paddingRight: '5%' }}>
                        <div style={{ display: 'flex', gap: 20 }}>
                            <div style={{ height: 35 }}>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={() => setShowSearch(!showSearch)}
                                    onKeyPress={() => setShowSearch(!showSearch)}
                                >
                                    <img src='/assets/icons/Search.png' alt='search icon' style={{ height: 35, width: 35, objectFit: 'contain' }} />
                                </div>
                                {
                                    showSearch && (
                                        <Modal
                                            isOpen={showSearch}
                                            toggle={() => { setShowSearch(false); setQuery(''); }}
                                            css={searchModal}
                                        >
                                            <div css={searchWrapper}>
                                                <Searchbar
                                                    loading={productListLoading}
                                                    placeholder='Search'
                                                    onChange={setQuery}
                                                    onKeyDown={handleOnKeyDown}
                                                    onClicked={handleSearch}
                                                    value={searchQuery}
                                                    mainCss={headerSearchHeader}
                                                    inputCss={inputStyles}
                                                />
                                            </div>
                                        </Modal>
                                    )
                                }
                            </div>
                            <div
                                role='button'
                                tabIndex={0}
                                onClick={handleProfileClicked}
                                onKeyPress={handleProfileClicked}
                                style={{ height: 35, cursor: `${startupLoading ? 'wait' : 'pointer'}`, pointerEvents: `${startupLoading ? 'none' : 'auto'}` }}
                            >
                                <img src='/assets/icons/Account.png' alt='search icon' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                            </div>
                        </div>
                        <div style={{ alignItems: 'center' }}>
                            <div style={{ height: 35 }}>
                                <div
                                    role='button'
                                    tabIndex={0}
                                    onClick={navToHome}
                                    onKeyPress={navToHome}
                                    style={{ height: 35 }}
                                >
                                    <img src='Logo.png' alt='Tiansi Logo' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 20 }}>
                            <div
                                role='button'
                                tabIndex={0}
                                onClick={navToWishlist}
                                onKeyPress={navToWishlist}
                                style={{ height: 35 }}
                            >
                                <img src='/assets/icons/Like.png' alt='search icon' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />
                            </div>
                            <div
                                role='button'
                                tabIndex={0}
                                onClick={navToCart}
                                onKeyPress={navToCart}
                                style={{ display: 'flex', height: 35 }}
                            >
                                <img src='/assets/icons/Cart.png' alt='search icon' style={{ height: '100%', width: '100%', objectFit: 'contain' }} />

                                {cartItems.reduce((acc, cur) => acc + cur.quantity, 0) > 0 && (
                                    <div style={{ width: 35, height: 25, marginLeft: -13, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#064E72', borderRadius: 50 }}>
                                        <p style={{ color: 'white', fontFamily: 'AcuminRPro', margin: 0 }}>
                                            {cartItems.reduce((acc, cur) => acc + cur.quantity, 0)}
                                        </p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ borderTop: '1px solid white', borderBottom: '1px solid white', paddingTop: 25, paddingBottom: 25, color: 'white' }}>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: 40 }}>
                        {
                            startupLoading ? (
                                <Skeleton height={29} width={300} />
                            ) : (
                                <>
                                    {
                                        listProductsCategories.map((item: IProductCategory) => {
                                            let nameOnly = item.name.split('- ').slice(1).join(' ').toLocaleLowerCase();
                                            // .replace(/(.*)- /, '').toLocaleLowerCase();

                                            if (nameOnly !== 'fine gold') {
                                                nameOnly = nameOnly.replace('gold', '');
                                            }

                                            if (nameOnly.length <= 2) {
                                                return null;
                                            }

                                            return (
                                                <View
                                                    key={item.id}
                                                    role='button'
                                                    tabIndex={0}
                                                    onClick={() => navCategories(item)}
                                                    onKeyPress={() => navCategories(item)}
                                                    css={navItem}
                                                >
                                                    <p css={navText}>{nameOnly}</p>
                                                </View>
                                            );
                                        })
                                    }

                                    <View onClick={() => { onOpen(); }} css={navItem}>
                                        <div style={{ paddingTop: 5, cursor: 'pointer' }}>
                                            <img src='/assets/icons/Hamburger.svg' alt='menu' />
                                        </div>
                                    </View>
                                </>

                            )
                        }
                    </div>
                </div>
            </div>

            <div css={mobileHeader}>
                <div style={{ height: 50 }} />
                {renderMobileHeader()}
            </div>

            <LoginSignUpModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
            />
        </>

    );
};

const mapStateToProps = (state: RootState) => ({
    categoriesLoading: Selectors.getProductsCategoriesAttempting(state),
    productListLoading: Selectors.getProductsListAttempting(state),
    categories: Selectors.getProductsCategories(state),
    collections: Selectors.getProductsCollections(state),
    cartItems: Selectors.getCartItems(state),
    searchQuery: Selectors.getUiSearchQuery(state),
    userId: Selectors.getUserId(state),
    isLoggedIn: Selectors.getAuthAuthToken(state),
    startupLoading: Selectors.getAuthStartupAttempting(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    setQuery: (query: string | '') => dispatch(Actions.uiSetSearchQuery(query)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
